<h2>Har du en speciallärarexamen och vill ansöka om behörighet utifrån den</h2>
<p>
    Du som har en speciallärarexamen ansöker om behörighet utifrån din examen som helhet. Du behöver alltså inte
    ansöka om behörighet i specifika ämnen eller skolformer. Vi kommer att bedöma din speciallärarexamen som en
    helhet och ge dig den behörighet du har rätt till.
</p>
<p>
    Om du har en specialpedagogexamen jämställs den med en speciallärarexamen om utbildningen påbörjats före
    utgången av 2008 och examen har utfärdats senast den 30 juni 2015.
</p>
<p>
    <app-link external="true"
        href="https://www.skolverket.se/regler-och-ansvar/lararlegitimation-och-forskollararlegitimation/regler-och-krav-for-lararlegitimation/larar--och-forskollararlegitimation-och-krav-for-att-fa-behorighet">
        Läs mer om specialpedagogexamen
    </app-link>
</p>

<app-form-group data-test-id="specialEducationTeacher-radio-group">
    <app-radio-button [control]="specialEducationTeacher" [value]="true">Ja, jag har en speciallärarexamen och ansöker
        om behörighet</app-radio-button>
    <app-radio-button [control]="specialEducationTeacher" [value]="false">Nej, jag har ingen speciallärarexamen
    </app-radio-button>
    <span *ngIf="error" class="text-error text-small">{{error}}</span>
</app-form-group>